/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router";

function SEO({ description, lang, meta, title, titleOrigin, image, keyword }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
            image
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;

  const ogImg = image || site.siteMetadata.image;

  const ogTitle = titleOrigin
    ? titleOrigin
    : title
    ? title
    : site.siteMetadata.title;
  const location = useLocation();
  const fixCanonical = pathName =>
    pathName[pathName.length - 1] === "/" ? pathName : `${pathName}/`;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title ? title : titleOrigin}
      titleTemplate={`%s | Tonic3`}
      link={[
        {
          rel: "canonical",
          href: `${site.siteMetadata.siteUrl}${fixCanonical(
            location.pathname
          )}`,
        },
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: ogTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: ogImg,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: ogTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: "robots",
          content: "index",
        },
        {
          name: "keywords",
          content: keyword,
        },
      ].concat(meta)}
    >
      <script>{`function initApollo(){var n=Math.random().toString(36).substring(7),o=document.createElement("script");
o.src="https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache="+n,o.async=!0,o.defer=!0,
o.onload=function(){window.trackingFunctions.onLoad({appId:"66313559aeda360300d84c9e"})},
document.head.appendChild(o)}initApollo();`}</script>
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
};

export default SEO;
